<template>
  <div class="ProjectDashboard">
    <header class="ProjectDashboard__masthead">
      <div class="ProjectDashboard__title-block">
        <v-app-bar-nav-icon class="ProjectDashboard__nav-toggle" @click="showDrawer()" />
        <div>
          <span class="zp-overline">{{ $t('projectStream') }}</span>
          <h1 class="ProjectDashboard__title">{{ $t('project_stats') }}</h1>
          <p class="ProjectDashboard__subtitle">{{ $t('dashboardStatsSubtitle') }}</p>
        </div>
      </div>
    </header>

    <div class="ProjectDashboard__menu-row">
      <DashboardMenu
        class="ProjectDashboard__menu"
        :project-id="projectId"
        :project-type="projectType"
        :can-update-project="can(USER_PERMISSIONS.updateProject)"
      />
    </div>

    <main class="ProjectDashboard__content">
      <TaskStats :project-id="projectId" />
    </main>
  </div>
</template>
<script>
import EventBus from '@/event-bus';
import DashboardMenu from '@/components/DashboardMenu.vue';
import {
  TEMPLATE_TYPE_ACTION_TITLES,
  TEMPLATE_TYPE_ICONS,
  TEMPLATE_TYPE_TITLES,
  USER_PERMISSIONS,
} from '@/lib/constants';
import TaskStats from '@/components/TaskStats.vue';
import PermissionsCheck from '@/components/PermissionsCheck';

export default {
  computed: {
    USER_PERMISSIONS() {
      return USER_PERMISSIONS;
    },
  },

  components: { TaskStats, DashboardMenu },

  mixins: [PermissionsCheck],

  props: {
    projectId: Number,
    projectType: String,
    userId: Number,
    userRole: String,
    user: Object,
  },

  data() {
    return {
      dateRanges: [{
        text: this.$t('pastWeek'),
        value: 'last_week',
      }, {
        text: this.$t('pastMonth'),
        value: 'last_month',
      }, {
        text: this.$t('pastYear'),
        value: 'last_year',
      }],
      users: [{
        text: this.$t('allUsers'),
        value: null,
      }],

      TEMPLATE_TYPE_ICONS,
      TEMPLATE_TYPE_TITLES,
      TEMPLATE_TYPE_ACTION_TITLES,
      stats: null,
      dateRange: 'last_week',
    };
  },

  methods: {
    showDrawer() {
      EventBus.$emit('i-show-drawer');
    },
  },
};
</script>
